import React from "react";

export const Loader = () => {
  return (
    <>
      <div className="loaderContainer">
        <h1>Loading...</h1>
      </div>
    </>
  );
};
